<template>
  <div class="currency_box">
    <el-carousel v-if="list && list.length!=0"
                 indicator-position="outside"
                 style="width:100%"
                 arrow="never"
                 height="380px">
      <el-carousel-item v-for="(x,y) in momentList"
                        :key="y+'x'">
        <div class="moment_list">
          <div v-for="(item,index) in x"
               @mouseenter="mouseover(index)"
               @mouseleave="mouseout"
               class="moment_item"
               :key="item">
            <el-image class="dong"
                      :style="{'transform':activeIndex==index?'scale(1.5)':''}"
                      :src="item.resourceUrl"
                      alt=""></el-image>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: {
    momentList: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  data () {
    return {
      activeIndex: -1,
      list: [
        { url: 'https://img0.baidu.com/it/u=2266992387,3653937162&fm=253&fmt=auto&app=138&f=JPEG?w=346&h=500', bg: 'linear-gradient(90deg, #1f8ffb, #0f54ec)' },
        { url: 'https://img2.baidu.com/it/u=1318432244,4009299303&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=711', bg: 'linear-gradient(90deg, #19CEAD, #00B292)' },
        { url: 'https://img2.baidu.com/it/u=2616025538,1484344267&fm=253&fmt=auto&app=138&f=JPEG?w=333&h=500', bg: 'linear-gradient(90deg, #FA6992, #EA2B61)' },
        { url: 'https://img2.baidu.com/it/u=154933639,2780893441&fm=253&fmt=auto&app=138&f=JPEG?w=392&h=500', bg: 'linear-gradient(90deg, #50D6BE, #4180F5)' },
        { url: 'https://img2.baidu.com/it/u=154933639,2780893441&fm=253&fmt=auto&app=138&f=JPEG?w=392&h=500', bg: 'linear-gradient(90deg, #50D6BE, #4180F5)' },
        { url: 'https://img2.baidu.com/it/u=1318432244,4009299303&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=711', bg: 'linear-gradient(90deg, #19CEAD, #00B292)' },
        { url: 'https://img2.baidu.com/it/u=2616025538,1484344267&fm=253&fmt=auto&app=138&f=JPEG?w=333&h=500', bg: 'linear-gradient(90deg, #FA6992, #EA2B61)' },
        { url: 'https://img2.baidu.com/it/u=154933639,2780893441&fm=253&fmt=auto&app=138&f=JPEG?w=392&h=500', bg: 'linear-gradient(90deg, #50D6BE, #4180F5)' },
      ]

    }
  },
  methods: {
    mouseover (index) {
      this.activeIndex = index
    },
    mouseout () {
      this.activeIndex = -1
    }
  }
}
</script>
<style lang="less" scoped>
.moment_list {
  // display: flex;
  width: 100%;
  margin-top: 20px;
  .moment_item {
    display: inline-block;
    width: calc((100% - 60px) / 4);
    height: 175px;
    background-color: red;
    margin-right: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    .dong {
      width: 100%;
      height: 100%;
      transition: all 2s;
      z-index: 11;
    }
  }

  .moment_item:nth-child(4) {
    margin-right: 0;
  }
  .moment_item:nth-child(8) {
    margin-right: 0;
  }
}
</style>